module.exports = __webpack_public_path__ + "ipetbooking/admin/img/cash.a2f40734.svg";